export var ReservationSearchType;
(function (ReservationSearchType) {
    ReservationSearchType["PICK_UP_AT"] = "PICK_UP_AT";
    ReservationSearchType["DROP_OFF_AT"] = "DROP_OFF_AT";
    ReservationSearchType["HISTORY_UPDATED_AT"] = "HISTORY_UPDATED_AT";
})(ReservationSearchType || (ReservationSearchType = {}));
